import 'rc-slider/assets/index.css';
import React, { Component } from 'react';
import Slider from 'rc-slider';
import PropertyNumberField from "./PropertyNumberInput";

const Handle = Slider.Handle;

const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Handle value={value} {...restProps}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 102">
                <g style={{ opacity: 0.8 }}>
                    <polygon style={{ fill: '#000000' }} points="58.841 0 0 102 117.682 102 58.841 0"/>
                </g>
                <g style={{ opacity: 0.8 }}>
                    <polygon style={{ fill: '#000000' }} points="58.841 102 58.841 0 128 0 58.841 102"/>
                </g>
            </svg>
        </Handle>
    );
};

class PropertyCalcControl extends Component {
    constructor(props) {
        super(props);

        this.onEnterPress = this.onEnterPress.bind(this);
    }

    onEnterPress(e) {
        if(this.props.preventEnter && (e.key === 'Enter' || e.target.keyCode === 13))
            e.preventDefault();
    }

    render() {
        return (
            <div className={['creditCalcControl', this.props.className].filter(className => !!className).join(' ')}>
                <label className="creditCalcControlLabel">
                    {this.props.label}
                    {this.props.subLabel && this.props.subLabel !== 'Annahme *' && <> <span className="creditCalcControl-sub-label">{this.props.subLabel}</span></>}
                    {this.props.subLabel && this.props.subLabel == 'Annahme *' && <><br></br><span style={{marginBottom: '0px'}} className="creditCalcControl-sub-label">{this.props.subLabel}</span></>}
                </label>

                <div className="creditCalcControlInner">
                    {typeof this.props.min !== 'undefined' && typeof this.props.max !== 'undefined' && typeof this.props.step !== 'undefined' &&
                        <Slider
                            className="creditCalcControlSlider"
                            handle={handle}
                            min={this.props.min}
                            max={this.props.max}
                            step={this.props.step}
                            value={this.props.value}
                            onChange={this.props.onSliderChange.bind(this, this.props.name)}
                            onAfterChange={this.props.onAfterChange}
                        />}
                    
                    <PropertyNumberField
                        className={this.props.readOnly ? "creditCalcControlInput-readonly" : "creditCalcControlInput"}
                        value={this.props.value}
                        name={this.props.name}
                        inputId={this.props.name}
                        change={this.props.onInputChange}
                        min={this.props.min}
                        max={this.props.max}
                        currency={this.props.currency | false}
                        decimals={this.props.decimals | 0}
                        readOnly={this.props.readOnly}
                        onKeyPress={this.onEnterPress}
                        tabIndex={this.props.tabIndex}
                    />
                </div>
            </div>
        );
    }
}

export default PropertyCalcControl;